import React from 'react';
import ReactLoading from 'react-loading';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, {
    CSVExport,
    Search,
} from 'react-bootstrap-table2-toolkit';
import moment from 'moment';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import FieldSelect from '../fields/FieldSelect';
import FieldDatePicker from '../fields/FieldDatePicker';
import PrintButton from '../common/PrintButton';

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const Reports = (props) => {
    const {
        isLoading,
        columns,
        products,
        reportTypeList,
        reportType,
        setReportType,
        startDate,
        momentStartDate,
        setStartDate,
        endDate,
        momentEndDate,
        setEndDate,
        generateReport,
        displayReportHeader,
    } = props;

    return (
        <div className='report'>
            <div className='card card--border card--stackable'>
                <div className='card__header'>
                    <h2 className='heading heading--lv4'>
                        <LocalizedMessage id={'REPORTS_HEADING'} />
                    </h2>
                    <div className='row'>
                        <div className='col-xs-12 col-md-8'>
                            <div className='row row--small'>
                                <div className='col-xs-12 col-md-6'>
                                    <FieldSelect
                                        required
                                        autoComplete='off'
                                        animatedLabel={'Report Type'}
                                        label={'Report Type'}
                                        value={reportType}
                                        name='Report Type'
                                        onChange={(e, value) =>
                                            setReportType(value)
                                        }
                                        options={reportTypeList}
                                    />
                                </div>
                                <div className='col-xs-6 col-md-3'>
                                    <FieldDatePicker
                                        selectStart
                                        selected={momentStartDate}
                                        startDate={momentStartDate}
                                        endDate={momentEndDate}
                                        autoComplete='off'
                                        dateFormat='DD/MM/YYYY'
                                        placeholder='dd/mm/yyyy'
                                        label={'From Date'}
                                        animatedLabel={'From Date'}
                                        name='From Date'
                                        value={startDate || ''}
                                        maxDate={momentEndDate}
                                        onChange={(date) => setStartDate(date)}
                                    />
                                </div>
                                <div className='col-xs-6 col-md-3'>
                                    <FieldDatePicker
                                        selectsEnd
                                        selected={momentEndDate}
                                        startDate={momentStartDate}
                                        endDate={momentEndDate}
                                        autoComplete='off'
                                        dateFormat='DD/MM/YYYY'
                                        placeholder='dd/mm/yyyy'
                                        label={'To Date'}
                                        animatedLabel={'To Date'}
                                        name='To Date'
                                        value={endDate || ''}
                                        minDate={momentStartDate}
                                        maxDate={moment().format('DD/MM/YYYY')}
                                        onChange={(date) => setEndDate(date)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-xs-12 col-md-4'>
                            <div className='text-box--right'>
                                <button
                                    type='button'
                                    className={`form__submit button button--field ${
                                        !reportType || isLoading
                                            ? 'button--disabled'
                                            : ''
                                    }`}
                                    disabled={!reportType || isLoading}
                                    onClick={() => {
                                        generateReport();
                                    }}
                                >
                                    <span>
                                        <LocalizedMessage
                                            id={'REPORTS_GENERATE_REPORT'}
                                        />
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card card--border card--stackable'>
                <div className='card__header report__card'>
                    {columns.length > 0 && products.length > 0 && (
                        <>
                            <div className='row row--vcenter'>
                                <div className='col-xs-7 col-md-8'>
                                    <h2 className='heading heading--lv4'>
                                        {displayReportHeader}
                                    </h2>
                                </div>
                                <div className='col-xs-5 col-md-4 tx-right'>
                                    <PrintButton />
                                </div>
                            </div>
                            <div>
                                <ToolkitProvider
                                    keyField={columns[0]['dataField']}
                                    data={products}
                                    columns={columns}
                                    exportCSV
                                    search
                                >
                                    {(props) => (
                                        <div>
                                            <div className='row row--vcenter'>
                                                <div className='col-xs-7 col-md-6'>
                                                    <SearchBar
                                                        {...props.searchProps}
                                                    />
                                                </div>
                                                <div className='col-xs-7 col-md-6 tx-right'>
                                                    <ExportCSVButton
                                                        {...props.csvProps}
                                                    >
                                                        <LocalizedMessage
                                                            id={
                                                                'REPORTS_EXPORT_CSV'
                                                            }
                                                        />
                                                    </ExportCSVButton>
                                                </div>
                                            </div>
                                            <BootstrapTable
                                                {...props.baseProps}
                                                pagination={paginationFactory({
                                                    hideSizePerPage: true,
                                                    hidePageListOnlyOnePage: true,
                                                    sizePerPage: 24,
                                                    prePageText: 'PREVIOUS',
                                                    nextPageText: 'NEXT',
                                                })}
                                                bordered={false}
                                            />
                                        </div>
                                    )}
                                </ToolkitProvider>
                            </div>
                        </>
                    )}
                    {isLoading && (
                        <ReactLoading
                            type='spin'
                            color='white'
                            height={20}
                            width={20}
                        />
                    )}
                    {products.length === 0 && !isLoading && (
                        <div className='react-table__dataless'>
                            <LocalizedMessage id={'TABLE_NO_ITEMS_FOUND'} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Reports;
